import * as monaco from 'monaco-editor';

export type GlobalMonacoEditor = monaco.editor.IStandaloneCodeEditor;
declare global {
	interface Window {
		testSuiteMonacoEditor: GlobalMonacoEditor | undefined;
	}
}

export class MonacoEditorEnvironment {
	static setup() {
		// async function _load_monaco_editor_js() {
		// 	// from https://github.com/microsoft/monaco-editor-samples/blob/master/browser-script-editor/index.html
		// 	(window as any).require = {paths: {vs: MONACO_EDITOR_BASE_URL}};

		// 	for (let script of SCRIPTS) {
		// 		const url = `${MONACO_EDITOR_BASE_URL}/${script}`;
		// 		const script_element = document.createElement('script');
		// 		script_element.src = url;
		// 		document.body.appendChild(script_element);
		// 		// await import(`${MONACO_EDITOR_BASE_URL}/${script}`);
		// 	}
		// }
		const monaco_setup_element = document.getElementById('monaco-setup');
		const json_url = monaco_setup_element?.dataset['json'] || '/editor/json.worker.js';
		const css_url = monaco_setup_element?.dataset['css'] || '/editor/css.worker.js';
		const html_url = monaco_setup_element?.dataset['html'] || '/editor/html.worker.js';
		const typescript_url = monaco_setup_element?.dataset['typescript'] || '/editor/ts.worker.js';
		const urls: Dictionary<string> = {
			json: json_url,
			css: css_url,
			html: html_url,
			typescript: typescript_url,
			javascript: typescript_url,
		};
		const default_url = monaco_setup_element?.dataset['editor'] || '/editor/editor.worker.js';
		(self as any).MonacoEnvironment = {
			getWorkerUrl: function (moduleId: any, label: string) {
				const url = urls[label] || default_url;
				return url;
			},
		};
	}
}
